var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOuterArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 16,
    viewBox: "0 0 42 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7071 7.2929C42.0976 7.68342 42.0976 8.31658 41.7071 8.70711L35.3431 15.0711C34.9526 15.4616 34.3195 15.4616 33.9289 15.0711C33.5384 14.6805 33.5384 14.0474 33.9289 13.6569L39.5858 8L33.9289 2.34315C33.5384 1.95262 33.5384 1.31946 33.9289 0.928934C34.3195 0.538409 34.9526 0.538409 35.3431 0.928934L41.7071 7.2929ZM4.37114e-08 7L41 7L41 9L-4.37114e-08 9L4.37114e-08 7Z",
    fill: "#2A86FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuterArrow);
export default __webpack_public_path__ + "static/media/OuterArrow.fd75232b7640c399bf65c1be60bcd726.svg";
export { ForwardRef as ReactComponent };